export var AdSlotIds;
(function (AdSlotIds) {
    AdSlotIds["AD_MEDIUM_RECTANGLE_1"] = "ad-medium-rectangle-1";
    AdSlotIds["AD_MEDIUM_RECTANGLE_2"] = "ad-medium-rectangle-2";
    AdSlotIds["AD_LEADERBOARD"] = "div-gam-ad-desktop-top-banner";
    AdSlotIds["AD_BANNER_MOBILE"] = "ad-banner-mobile";
    AdSlotIds["PARTNERBOX_1_COMMERCIAL"] = "partnerbox-1-commercial";
    AdSlotIds["PARTNERBOX_2_COMMERCIAL"] = "partnerbox-2-commercial";
    AdSlotIds["PARTNERBOX_3_TOOLS_AND_SERVICE"] = "partnerbox-3-tools-and-service";
    AdSlotIds["PARTNERBOX_4_TOOLS_AND_SERVICE"] = "partnerbox-4-tools-and-service";
    AdSlotIds["PARTNERBOX_5_TOOLS_AND_SERVICE"] = "partnerbox-5-tools-and-service";
    AdSlotIds["AD_MEDIUM_RECTANGLE_MOBILE"] = "ad-medium-rectangle-mobile";
    AdSlotIds["AD_MASONRY"] = "ad-masonry";
    AdSlotIds["AD_CAROUSEL"] = "ad-carousel";
    AdSlotIds["RENTAL_LINK"] = "rental-link";
})(AdSlotIds || (AdSlotIds = {}));
